<div class="row tax-planning-client">
  <div class="medium-12 columns">
    <label>
      Name*
      <input type="text" [(ngModel)]="anouncement.name" placeholder="Name"/>
    </label>
  </div>
  <div class="medium-6 columns">
    <label>
      Start Date
      <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'MM/DD/YYYY'" [mindate]="currentDate" [(ngModel)]="anouncement.startDate"
             (valueChanged)="setAnouncementDate($event, 'start')"  placeholder="Start Date"/>
    </label>
  </div>
  <div class="medium-6 columns">
    <label>
      End Date
      <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'MM/DD/YYYY'" [mindate]="currentDate" [(ngModel)]="anouncement.endDate"
             (valueChanged)="setAnouncementDate($event, 'end')"  placeholder="End Date"/>
    </label>
  </div>
  <div class="medium-6 columns">
    <label>
      No of Times to Display
      <input type="number" [(ngModel)]="anouncement.noOfTimesToDisplay" placeholder="No of Times to Display"/>
    </label>
  </div>
  <div class="medium-12 columns">
    <label>
      Description
      <div class="description-edit-box" [froalaEditor]="editorOptions" [(froalaModel)]="anouncement.description"></div>
    </label>
  </div>
</div>
<div class="row" style="margin-top: 20px;">
  <div class="medium-12">
    <button class="button small float-right" *ngIf="org == 'trialtaxplaniq' || org == 'test-taxplaniq' || org == 'stag-taxplaniq'" (click)="saveAnouncement()">{{editMode? "Update": "Create"}}</button>
    <button class="button small float-right" style="border: 1px solid #D0D5DD;border-radius: 6px;background: #FFFFFF;color:#333333;" (click)="closeCreateOrUpdatePopup()">Cancel</button>
  </div>
</div>
